import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Config } from '../../config';
import * as L from 'leaflet';
import { CableDetailsDialogComponent } from 'src/app/cable-details-dialog/cable-details-dialog.component';
import { Cable } from 'src/app/_models/cable';
import { CableColor } from 'src/app/_models/cable-color';
import { Condition } from 'src/app/_models/condition';
import { GridColor } from 'src/app/_models/grid-color';
import { GridElement } from 'src/app/_models/grid-element';
import { GMonResultsAvailableMessage, LAResultsAvailableMessage, RPAResultsAvailableMessage } from 'src/app/_models/mqtt-message';
import { TopologyConfig, TopologyList, TopologyWithRoot } from 'src/app/_models/topology-list';
import { ConfigurationService } from 'src/app/_services/configuration/configuration.service';
import { GMonService } from 'src/app/_services/gmon-service/gmon.service';
import { GridElementService } from 'src/app/_services/grid-element/grid-element.service';
import { LaService } from 'src/app/_services/la-service/la.service';
import { MapService } from 'src/app/_services/map/map.service';
import { ReactivePowerAnalysisService } from 'src/app/_services/reactive-power-analysis-service/reactive-power-analysis.service';
import { environment } from 'src/environments/environment';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalService } from 'src/app/_services/modal/modal.service';
import { GPlanService } from 'src/app/_services/gplan-service/gplan.service';


@Component({
  selector: 'app-map-view-dialog',
  templateUrl: './map-view-dialog.component.html',
  styleUrls: ['./map-view-dialog.component.css']
})
export class MapViewDialogComponent implements OnInit {

  private excludedNodes: any;
  private topology: any;
  public topologiesWithRoots: Array<TopologyWithRoot>;
  public open: any;
  public closed: any;
  public mixed: any;
  public basiAlertTitleAttention: any;
  public basiAlertMessageSelectCCB: any;
  public basiAlertMessageSelectSSB: any;
  public basiAlertMessageSelectMVStatin: any;
  private map2: L.map;
  private gridNodesLayer: L.layerGroup;
  private cablesLayer: L.layerGroup;
  private cablesLayerOpen: L.layerGroup;
  private switchLayer: L.layerGroup;
  private nodesMap: Map<number, GridElement> = new Map<number, GridElement>();
  private cablesMap: Map<number, Cable> = new Map<number, Cable>();
  private cables: Array<Cable> = new Array<Cable>();
  private gridColorApps: Map<number, GridColor> = new Map<number, GridColor>();
  private cableColorApps: Map<number, CableColor> = new Map<number, CableColor>();
  public showIds: boolean = true;
  public topologies: TopologyList;
  public translations: any;

  constructor(
    private modalService: ModalService,
    private changeDetector: ChangeDetectorRef,
    public activeModal: NgbActiveModal,
    private ngbModal: NgbModal,
    private gMonService: GMonService,
    private laService: LaService,
    private mapService: MapService,
    private gridElementService: GridElementService,
    private reactivePowerAnalysisService: ReactivePowerAnalysisService,
    public translate: TranslateService,
    private configurationService: ConfigurationService,
    private gplanService: GPlanService
  ) {
    this.excludedNodes = environment.EXCLUDED_NODES;
    // Translations
    const language = localStorage.getItem("Language");
    translate.getTranslation(language).subscribe((translations) => {
      this.translations = translations;
      this.basiAlertTitleAttention = translations["code-string"]['attention'];
      this.basiAlertMessageSelectCCB = translations["code-string"]['select-ccb-node'];
      this.basiAlertMessageSelectSSB = translations["code-string"]['select-ssb-node']
      this.basiAlertMessageSelectMVStatin = translations["code-string"]['select-mv-station'];
    });
  }


  ngOnInit() {
    setTimeout(() => {
      this.topology = JSON.parse(localStorage.getItem("currentTopology"));
      this.getAvailableTopologies(this.topology.topologyId)
    });
  }

  getAvailableTopologies(topology: string) {
    this.mapService.getAvailableTopologies().subscribe((response: TopologyList) => {
      if (response) {
        this.topologies = response
        this.topologiesWithRoots = this.topologies.topologiesWithRoots
        this.topologiesWithRoots.forEach(element => {
          if (element.TopologyId == topology) {
            let topologyConfig: TopologyConfig = new TopologyConfig(
              element.TopologyId,
              element.latitude,
              element.longitude,
              element.lastTopologyChange
            )
            localStorage.setItem("currentTopology", JSON.stringify(topologyConfig))
            this.topology = topologyConfig;
            this.loadMap('map2');
            //this.getApplicationsStatus();
          }
        });
      }
    });
    /*
        let topologies_local = JSON.parse(localStorage.getItem("topologies"));
            this.topologiesWithRoots = topologies_local.topologiesWithRoots
            this.topologiesWithRoots.forEach(element => {
              if (element.TopologyId == topology) {
                let topologyConfig: TopologyConfig = new TopologyConfig(
                  element.TopologyId,
                  element.latitude,
                  element.longitude
                )
                localStorage.setItem("currentTopology", JSON.stringify(topologyConfig))
                this.topology = topologyConfig;
                this.loadMap('map2');
                //this.getApplicationsStatus();
              }
            });*/
  };


  /*private getApplicationsStatus() {
    this.guiService.getApplicationsStatus(this.topology.topologyId).subscribe((applicationStatuses: ApplicationStatus) => {
      if (applicationStatuses) {

        console.log(applicationStatuses);

        localStorage.setItem("isGMonRunning", JSON.stringify(applicationStatuses.isGMonRunning));
        localStorage.setItem("isGPlanRunning", JSON.stringify(applicationStatuses.isGPlanRunning));
        localStorage.setItem("isLARunning", JSON.stringify(applicationStatuses.isLARunning));
        localStorage.setItem("isLCRunning", JSON.stringify(applicationStatuses.isLCRunning));
        localStorage.setItem("isReactivePowerAnalysisRunning", JSON.stringify(applicationStatuses.isReactivePowerAnalysisRunning));
        localStorage.setItem("areLcDataAvailable", JSON.stringify(applicationStatuses.areLcDataAvailable));
        localStorage.setItem("areGplanDataAvailable", JSON.stringify(applicationStatuses.areGplanDataAvailable));
        localStorage.setItem("areFrequencyDataAvailable", JSON.stringify(applicationStatuses.areFrequencyDataAvailable));
        localStorage.setItem("areVoltageDataAvailable", JSON.stringify(applicationStatuses.areVoltageDataAvailable));
        if (applicationStatuses.areLANodeDataAvailable || applicationStatuses.areLACableDataAvailable) {
          localStorage.setItem("areLADataAvailable", 'true');
        }
        localStorage.setItem("areRPADataAvailable", JSON.stringify(applicationStatuses.areRPADataAvailable));//

        this.manageRpaResultsColoring(applicationStatuses.rpaGUIColoringInfoDto);
        console.log("manage rpa coloring")

        this.manageGMonResultsColoring(applicationStatuses.gMonGUIColoringInfoDtoDto);
        console.log("manage gmon coloring")

        this.manageLAResultsColoring(applicationStatuses.laGuiColoringInfoDto);
        console.log("manage la coloring")

      }
    });

  }*/

  private loadMap(mapId: string) {
    if (this.map2 != undefined) { // https://stackoverflow.com/questions/19186428/refresh-leaflet-map-map-container-is-already-initialized
      this.map2.off();
      this.map2.remove();
    }
    this.map2 = this.mapService.buildBaseMap(mapId);
    this.loadGridElementsOnMap(this.map2);
  }


  private manageGMonResultsColoring(gmonResultsAvailableMessage: GMonResultsAvailableMessage) {
    this.initGridColors();

    //if mqtt message is defined
    if (gmonResultsAvailableMessage) {
      let areFrequencyResultsAvaiable: boolean = gmonResultsAvailableMessage.areFrequencyResultsAvaiable
      let areVoltageResultsAvaiable: boolean = gmonResultsAvailableMessage.areVoltageResultsAvaiable

      //set "areVoltageDataAvailable" and "areFrequencyDataAvailable"
      this.gMonService.setDataAvailable('areVoltageDataAvailable', areVoltageResultsAvaiable);
      this.gMonService.setDataAvailable('areFrequencyDataAvailable', areFrequencyResultsAvaiable);

      //if voltage results are available
      if (areVoltageResultsAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          let numberOfDaysRequestedByUser: number = 0;
          if (gmonResultsAvailableMessage.numberOfDaysRequestedByUser) {
            numberOfDaysRequestedByUser = gmonResultsAvailableMessage.numberOfDaysRequestedByUser
          }
          if (gmonResultsAvailableMessage.voltageViolationsPerGridelementId) {
            let numberOfVoltageViolations = gmonResultsAvailableMessage.voltageViolationsPerGridelementId[gridElement.gridElementId]
            gridColorTemp.voltage = this.getConditionVoltage(numberOfVoltageViolations, numberOfDaysRequestedByUser);
          }

          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });

        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }
      //else voltage results are not available
      else {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.voltage = Condition.NORMAL;;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //if frequency results are available
      if (areFrequencyResultsAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);

          let numberOfDaysRequestedByUser: number = 0;
          if (gmonResultsAvailableMessage.numberOfDaysRequestedByUser) {
            numberOfDaysRequestedByUser = gmonResultsAvailableMessage.numberOfDaysRequestedByUser
          }

          if (gmonResultsAvailableMessage.frequencyViolationsPerGridelementId) {
            let numberOfFrequencyViolations = gmonResultsAvailableMessage.frequencyViolationsPerGridelementId[gridElement.gridElementId]
            gridColorTemp.frequency = this.getConditionFrequency(numberOfFrequencyViolations, numberOfDaysRequestedByUser);
          }
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);

          return gridElement;
        });

        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //else frequency results are not available
      else {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.frequency = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }
    }
  }


  public getConditionVoltage(numberOfViolations: number, numberOfDay: number): Condition {
    let condition: Condition = Condition.NORMAL;
    //    console.log("numberOfDay: " + numberOfDay);
    if (numberOfDay !== 0) {
      numberOfViolations = numberOfViolations / numberOfDay;
    } else {
      throw new Error("Number of days is " + numberOfDay);
      return;
    }
    // console.log("numberOfViolations: " + numberOfViolations);
    if (numberOfViolations > 0) {
      const x = numberOfViolations; // / this.data.average.length;
      if (
        x > this.configurationService.getConfiguration().normalMaxViolationsRatio &&
        x <= this.configurationService.getConfiguration().attentionMaxViolationsRatio
      ) {
        condition = Condition.ATTENTION;
      }
      if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatio) {
        condition = Condition.PROBLEM;
      }
    }
    return condition;
  }

  public getConditionFrequency(numberOfFrequencyViolations: number, numberOfDay: number): Condition {
    let condition: Condition = Condition.NORMAL;
    if (numberOfDay !== 0) {
      numberOfFrequencyViolations = numberOfFrequencyViolations / numberOfDay;
    } else {
      throw new Error("Number of days is " + numberOfDay);
      return;
    }
    // console.log("numberOfViolations: " + numberOfViolations);
    if (numberOfFrequencyViolations > 0) {
      const x = numberOfFrequencyViolations;
      if (
        numberOfFrequencyViolations > this.configurationService.getConfiguration().normalMaxViolationsRatioFrequency &&
        x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioFrequency
      ) {
        condition = Condition.ATTENTION;
      }
      if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioFrequency) {
        condition = Condition.PROBLEM;
      }
    }
    return condition;
  }

  public getLaCondition(numberOfViolations: number, numberOfDayLA: number): Condition {
    let condition: Condition = Condition.NORMAL;
    if (numberOfDayLA !== 0) {
      numberOfViolations = numberOfViolations / numberOfDayLA;
    } else {
      throw new Error(('Number of days is ' + numberOfDayLA));
      // return;
    }
    console.log("numberOfViolations-LA: " + numberOfViolations);
    console.log("normalMaxViolationsRatioLA: " + this.configurationService.getConfiguration().normalMaxViolationsRatioLA);
    console.log("attentionMaxViolationsRatioLA: " + this.configurationService.getConfiguration().attentionMaxViolationsRatioLA);
    if (numberOfViolations > 0) {
      const x = numberOfViolations; // / this.data.average.length;

      if (x >= this.configurationService.getConfiguration().normalMaxViolationsRatioLA
        && x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioLA) {
        condition = Condition.ATTENTION;
      }
      if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioLA) {
        condition = Condition.PROBLEM;
      }
    }
    return condition;
  }

  // Redraw Nodes layer
  redrawNodesLayer(gridElements: Array<GridElement>) {
    console.log("redrawNodesLayer")
    console.log(this.gridNodesLayer)

    if (this.gridNodesLayer)
      this.map2.removeLayer(this.gridNodesLayer);

    const markers: Array<L.marker> = this.drawGridElementsOnMap(gridElements, this.showIds);
    this.gridNodesLayer = L.layerGroup(markers);
    this.gridNodesLayer.addTo(this.map2);
    try {
         localStorage.setItem('gridElements', JSON.stringify(gridElements));
    } catch (e) {
         console.error('Failed to save gridElements:', e);
    }
  }

  // Change Cables color
  redrawCablesLayer() {
    if (this.cablesLayer) {
      this.map2.removeLayer(this.cablesLayer);
    }
    this.drawCablesOnMap(this.map2, this.cables);
  }

  private manageLAResultsColoring(laResultsAvailableMessage: LAResultsAvailableMessage) {
    this.initGridColors();
    this.initCableColors();
    //if message is defined
    if (laResultsAvailableMessage) {

      let numberOfDaysRequestedByUser = laResultsAvailableMessage.numberOfDaysRequestedByUser
      let areNodeResultsAvaiable = laResultsAvailableMessage.areNodeResultsAvaiable
      let areCableResultsAvaiable = laResultsAvailableMessage.areCableResultsAvaiable

      // set "areLADataAvailable" variable on localstorage
      if (areNodeResultsAvaiable == true || areCableResultsAvaiable == true) {
        this.laService.setLADataAvailable(true)
      }
      else {
        this.laService.setLADataAvailable(false)
      }

      //if node results are available
      if (areNodeResultsAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          if (laResultsAvailableMessage.nodeViolationsPerGridelementId) {
            let nodeViolationsPerGridelementId = laResultsAvailableMessage.nodeViolationsPerGridelementId[gridElement.gridElementId]
            if (nodeViolationsPerGridelementId) {
              gridColorTemp.la = this.getLaCondition(nodeViolationsPerGridelementId, numberOfDaysRequestedByUser);
            }
          }
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //if node results are not available
      else {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
          const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
          gridColorTemp.la = Condition.NORMAL;
          gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
          return gridElement;
        });
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }


      const cablesJson: string = localStorage.getItem('cables');
      const cableGridElementIds: Array<number> = new Array<number>();
      if (this.cables.length > 0) {
        this.cables.forEach((cable: any) => {
          cableGridElementIds.push(cable.gridElementId);
        });
      } else if (cablesJson) {
        this.cables = JSON.parse(cablesJson);
        if (this.cables == null || this.cables.length === 0) {
          this.loadCablesOnMap(this.map2);
        }
        this.cables.forEach((cable: any) => {
          cableGridElementIds.push(cable.gridElementId);
        });
      }


      //if cable results are available
      if (areCableResultsAvaiable) {
        Array.from(this.cablesMap.values()).map((cable: Cable) => {

          if (laResultsAvailableMessage.cableViolationsPerGridelementId) {
            let cableViolationsPerGridelementId = laResultsAvailableMessage.cableViolationsPerGridelementId[cable.gridElementId]
            const newColor = this.getColorCable(cableViolationsPerGridelementId, numberOfDaysRequestedByUser);
            const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);
            if (cableColorTemp) {
              cableColorTemp.la = newColor;
            }
            cable.color = newColor;
          }
          // console.log(cable.gridElementId + ' ; ' + cable.color);
          return cable;
        });

        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
         } catch (e) {
             console.error('Failed to save cables:', e);
         }
        this.redrawCablesLayer();
      }

      //if cable results are not available
      else {

        Array.from(this.cablesMap.values()).map((cable: Cable) => {
          const newColor = Config.CONDITION_COLOR_NORMAL;
          const cableColorTemp = this.cableColorApps.get(+cable.gridElementId);
          cableColorTemp.la = newColor;
          cable.color = newColor;
          // console.log(cable.gridElementId + ' ; ' + cable.color);
          return cable;
        });

        try {
          localStorage.setItem('cables', JSON.stringify(this.cables));
         } catch (e) {
             console.error('Failed to save cables:', e);
         }
        this.redrawCablesLayer();
      }
    }
  }


  public getColorCable(numberOfViolations: number, numberOfDayLA: number): string {
    let color: string = Config.CONDITION_COLOR_NORMAL;
    console.log("numberOfDayLA: " + numberOfDayLA);
    if (numberOfDayLA !== 0) {
      numberOfViolations = numberOfViolations / numberOfDayLA;
    } else {
      throw new Error(('Number of days is ' + numberOfDayLA));
      // return;
    }
    console.log("numberOfViolations-LA: " + numberOfViolations);
    if (numberOfViolations > 0) {
      const x = numberOfViolations; // / this.data.average.length;

      if (x >= this.configurationService.getConfiguration().normalMaxViolationsRatioLACable
        && x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioLACable) {
        color = Config.CONDITION_COLOR_ATTENTION;
      }
      if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioLACable) {
        color = Config.CONDITION_COLOR_PROBLEM;
      }
    }
    return color;
  }

  private manageRpaResultsColoring(rpaResultsAvailableMessage: RPAResultsAvailableMessage) {
    // this.reactivePowerAnalysisService.setReactivePowerAnalysisRunning(false);
    this.initGridColors();

    //if mqtt message is defined
    if (rpaResultsAvailableMessage) {

      let isDataAvaiable: boolean = rpaResultsAvailableMessage.isDataAvaiable;
      let numberOfDaysRequestedByUser: number = rpaResultsAvailableMessage.numberOfDaysRequestedByUser
      this.reactivePowerAnalysisService.setRPADataAvailable(isDataAvaiable)
      let ids = this.gridElementService.getAllTransformerIds();

      //if data are available
      if (isDataAvaiable == true) {
        Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {

          if (rpaResultsAvailableMessage.nodeViolationsPerGridelementId) {
            let nodeViolationsPerGridelementId: number = rpaResultsAvailableMessage.nodeViolationsPerGridelementId[gridElement.gridElementId]
            const newCondition: Condition = this.getConditionRPA(nodeViolationsPerGridelementId, numberOfDaysRequestedByUser);
            const gridColorTemp = this.gridColorApps.get(+gridElement.gridElementId);
            gridColorTemp.rpa = newCondition;
            if (gridElement.condition !== newCondition) {
              gridElement.condition = this.gridElementService.getGridElementCondition(gridColorTemp);
            }
          }
          return gridElement;
        });
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }

      //if data are not available
      else {
        console.log(ids)
        ids.forEach(id => {
          Array.from(this.nodesMap.values()).map((gridElement: GridElement) => {
            if (+gridElement.gridElementId == +id) {
              gridElement.condition = Condition.NORMAL;
              return gridElement;
            }
          });
        });
        this.redrawNodesLayer(Array.from(this.nodesMap.values()));
      }
    }
  }

  getConditionRPA(nodeViolationsPerGridelementId: number, numberOfDaysRequestedByUser_: number) {
    let condition: Condition = Condition.NORMAL;
    if (numberOfDaysRequestedByUser_ !== 0) {
      nodeViolationsPerGridelementId = nodeViolationsPerGridelementId / numberOfDaysRequestedByUser_;
    } else {
      throw new Error(('Number of days must not be ' + numberOfDaysRequestedByUser_));
    }
    console.log("numberOfViolations: " + nodeViolationsPerGridelementId);
    if (nodeViolationsPerGridelementId > 0) {
      const x = nodeViolationsPerGridelementId; // / this.data.average.length;
      if (x > this.configurationService.getConfiguration().normalMaxViolationsRatioRPA
        && x <= this.configurationService.getConfiguration().attentionMaxViolationsRatioRPA) {
        condition = Condition.ATTENTION;
      }
      if (x > this.configurationService.getConfiguration().attentionMaxViolationsRatioRPA) {
        condition = Condition.PROBLEM;
      }
    }
    return condition;
  }

  private drawGridElementsOnMap(gridElements: Array<GridElement>, showIds: boolean): Array<L.marker> {
    const markers: Array<L.marker> = new Array<L.marker>();
    console.log("IS hte trafo tab checked: >>> " , this.gplanService.isTrafoTabChecked)
    // this.gplanService.nodeOrTrafoTab$.subscribe((tabNumber) => {
      gridElements.forEach((gridElement: GridElement) => {
        // console.log("Index:   " + this.excludedNodes.indexOf(gridElement.elementSubType));
        if (this.excludedNodes.indexOf(gridElement.elementSubType) != -1) {
          // if (environment.EXCLUDED_NODES.indexOf(gridElement.elementSubType) != -1) {
          return;
        }

        const marker = this.mapService.buildGridNodeMarker(gridElement, this.showIds)

        // if (marker && tabNumber == 1) {
          // console.log("The tab number is changed look at it .///. ", tabNumber)
          if(!this.gplanService.isTrafoTabChecked){
            marker.on('click', (data) => {
              console.log(data)

              let gridTypeJson: string = JSON.parse(localStorage.getItem('gridType'));
              if (gridTypeJson == "LV") {

                if (data && data.target && data.target.options && data.target.options.title) {
                  if (data.target.options.title.includes("[CCB]") ||
                    data.target.options.title.includes("[CustomerConnectionBox]")) {
                    this.activeModal.dismiss(data)
                  }
                  else {

                    this.modalService.openBasicAlert(this.basiAlertTitleAttention, this.basiAlertMessageSelectCCB)
                  }
                }
              }

              if (gridTypeJson == "MV") {

                if (data && data.target && data.target.options && data.target.options.title) {
                  if (data.target.options.title.includes("[MV-Station]") || data.target.options.title.includes("[MV_Station]") ||
                      data.target.options.title.includes("[MS_Station]") || data.target.options.title.includes("MS Station") ||
                      data.target.options.title.includes("MS-Station")) {
                    this.activeModal.dismiss(data)
                  }
                  else {

                    this.modalService.openBasicAlert(this.basiAlertTitleAttention, this.basiAlertMessageSelectMVStatin)
                  }
                }
              }


            });
          }else{
            marker.on('click', (data) => {
              console.log(data)

              let gridTypeJson: string = JSON.parse(localStorage.getItem('gridType'));
              if (gridTypeJson == "LV") {

                if (data && data.target && data.target.options && data.target.options.title) {
                  if (data.target.options.title.includes("[SSB]") /*||
                    data.target.options.title.includes("[CustomerConnectionBox]")*/) {
                    this.activeModal.dismiss(data)
                  }
                  else {

                    this.modalService.openBasicAlert(this.basiAlertTitleAttention, this.basiAlertMessageSelectSSB)
                  }
                }
              }

              if (gridTypeJson == "MV") {

                if (data && data.target && data.target.options && data.target.options.title) {
                  if (data.target.options.title.includes("[MV-Station]") || data.target.options.title.includes("[MV_Station]") ||
                      data.target.options.title.includes("[MS_Station]") || data.target.options.title.includes("MS Station") ||
                      data.target.options.title.includes("MS-Station") || data.target.options.title.includes("[SSB]")) {
                    this.activeModal.dismiss(data)
                  }
                  else {

                    this.modalService.openBasicAlert(this.basiAlertTitleAttention, this.basiAlertMessageSelectMVStatin)
                  }
                }
              }


            });
          }

          markers.push(marker);

      });
    return markers;
  }



  private loadGridElementsOnMap(map: L.map) {
    let gridElements = JSON.parse(localStorage.getItem('gridElements'));
    gridElements.forEach((gridElement: GridElement) => {
      gridElement.condition = Condition.NORMAL;
      this.nodesMap.set(
        parseInt(gridElement.gridElementId.toString()),
        new GridElement(
          gridElement.gridElementId,
          gridElement.elementSubType,
          gridElement.properties,
          gridElement.condition
        ));
    });
    const markers: Array<L.marker> = this.drawGridElementsOnMap(Array.from(this.nodesMap.values()), this.showIds);
    this.gridNodesLayer = L.layerGroup(markers);
    this.gridNodesLayer.addTo(map);

    this.initGridColors();
    this.loadCablesOnMap(this.map2);
    //this.getApplicationsStatus();
  }

  private drawCablesOnMap(map: L.map, cables: Array<Cable>): void {
    const polylines: Array<L.polyline> = new Array<L.polyline>();
    const polylinesOpen: Array<L.polyline> = new Array<L.polyline>();
    const markerSwitches: Array<L.marker> = new Array<L.marker>();

    const myRenderer = L.canvas({ padding: 0.5, tolerance: 10 });
    console.log("onMap");
    console.log(cables);
    for (const cable of cables) {
      if (cable.switchingState == "OPEN") {
        let dashArrayProperty = null;


        console.log("OPEN ");
        console.log(cable);
        dashArrayProperty = "7,7"


        if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon) {

          let coordinates = [];
          if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon) {
            coordinates = [
              [cable.startNodeLat, cable.startNodeLon],
              [cable.endNodeLat, cable.endNodeLon]
            ];
          }

          //get middle coordinates of a cable
          let sourceLatitudeRadiant = cable.startNodeLat  * (Math.PI / 180);
          let destinationLatitudeRadiant = cable.endNodeLat  * (Math.PI / 180);
          let middleLatitudeRadiant = Math.atan(Math.sinh(Math.log(Math.sqrt(
            (Math.tan(destinationLatitudeRadiant)+1/Math.cos(destinationLatitudeRadiant))*(Math.tan(sourceLatitudeRadiant)+1/Math.cos(sourceLatitudeRadiant))))));
          let middleLatitude = middleLatitudeRadiant * (180 / Math.PI)
          let middleLongitude = (cable.startNodeLon + cable.endNodeLon) / 2;

          //create a marker for switch icon
          const markerSwitch = this.mapService.buildSwitchMarker(middleLatitude, middleLongitude);
          if(markerSwitch){
            markerSwitches.push(markerSwitch);
          }

          const polyline = L.polyline(coordinates, {

            renderer: myRenderer,
            color: cable.color,
            weight: cable.weight,
            dashArray: dashArrayProperty
          }).on('click', (data) => {
          });

          polylinesOpen.push(polyline);
        }
      }
      if (cable.switchingState != "OPEN") {
        let dashArrayProperty = null;
        if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon) {
          let coordinates = [];
          if (cable.startNodeLat && cable.startNodeLon && cable.endNodeLat && cable.endNodeLon) {
            coordinates = [
              [cable.startNodeLat, cable.startNodeLon],
              [cable.endNodeLat, cable.endNodeLon]
            ];
          }
          const polyline = L.polyline(coordinates, {
            renderer: myRenderer,
            color: cable.color,
            weight: cable.weight,
            dashArray: dashArrayProperty
          }).on('click', (data) => {
          });


          polylines.push(polyline);
        }
      }
    }

    // this.map.removeLayer(this.cablesLayer);
    this.switchLayer = L.layerGroup(markerSwitches);
    this.switchLayer.addTo(map);
    this.cablesLayerOpen = L.layerGroup(polylinesOpen);
    this.cablesLayer = L.layerGroup(polylines);
    this.cablesLayerOpen.addTo(map);
    this.cablesLayer.addTo(map);
  }

  private loadCablesOnMap(map: L.map) {
    const cablesJson: string = localStorage.getItem('cables');
    console.log("loadCablesOnMap -> cablesJson: ");
    console.log(cablesJson);

    if (cablesJson) {
      this.cables = JSON.parse(cablesJson);

      if (this.cables && this.cables.length != 0) {

        this.cables.forEach((cable: Cable) => {
          // cable.condition = Condition.NORMAL;
          this.cablesMap.set(
            parseInt(cable.gridElementId.toString()),
            cable
          );
        });

        this.cables = this.setCableColors(this.cables);
        this.cables = this.cables.map((cable: Cable) => {
          // if (!cable.color) {
          //   cable.color = Config.CONDITION_COLOR_NORMAL;
          // }
          cable.weight = 1;
          return cable;
        });

        this.drawCablesOnMap(map, this.cables);
      }
    }
  }


  // private initGridColors(appName?: string) {
  private initGridColors() {
    const gridColorAppsJson: string = localStorage.getItem('gridColorApps');
    if (gridColorAppsJson) {
      const gridColorAppsArray = JSON.parse(gridColorAppsJson);
      if (gridColorAppsArray.length != 0) {
        gridColorAppsArray.forEach(gc => {
          const gridColor = new GridColor(gc.gridElementId);
          gridColor.voltage = gc.voltage;
          gridColor.voltageGP = gc.voltageGP;
          gridColor.frequency = gc.frequency;
          gridColor.la = gc.la;
          gridColor.laGP = gc.laGP;
          gridColor.rpa = gc.rpa;
          this.gridColorApps.set(+gridColor.gridElementId, gridColor);
        });
        return;
      }
    }
    const gridElementsJson: string = localStorage.getItem('gridElements');
    if (gridElementsJson) {
      const gridElements: Array<GridElement> = JSON.parse(gridElementsJson);
      gridElements.forEach(gridElem => {
        this.gridColorApps.set(+gridElem.gridElementId, new GridColor(+gridElem.gridElementId, gridElem.condition));
      });
    } else {
      console.log('not gridElements loaded yet');
    }
  }

  private setGridColors(gridElements: Array<GridElement>) {
    this.initGridColors();
    gridElements.forEach((gridElement: GridElement) => {
      const gridColor = this.gridColorApps.get(+gridElement.gridElementId);
      gridElement.condition = gridColor.getHighestCondition();
    });
    return gridElements;
  }

  private initCableColors() {
    const cableColorAppsJson: string = localStorage.getItem('cableColorApps');
    if (cableColorAppsJson) {
      const cableColorAppsArray = JSON.parse(cableColorAppsJson);
      if (cableColorAppsArray.length != 0) {
        cableColorAppsArray.forEach(cc => {
          const cableColor = new CableColor(cc.gridElementId);
          cableColor.la = cc.la;
          cableColor.laGP = cc.laGP;
          this.cableColorApps.set(+cableColor.gridElementId, cableColor);
        });
        // console.log('cableColorApps in init: ' + JSON.stringify(Array.from(this.gridColorApps.values())));
        return;
      }
    }
    const cablesJson: string = localStorage.getItem('cables');
    if (cablesJson) {
      const cables: Array<Cable> = JSON.parse(cablesJson);
      cables.forEach(cableElem => {
        this.cableColorApps.set(+cableElem.gridElementId, new CableColor(+cableElem.gridElementId, cableElem.color));
      });
    } else {
      console.log('not cable-Elements loaded yet');
    }
  }

  private setCableColors(cables: Array<Cable>) {
    this.initCableColors();

    cables.forEach((cable: Cable) => {
      const cableColor = this.cableColorApps.get(+cable.gridElementId);
      if (cableColor) {
        cable.color = cableColor.la;
      }
    });
    return cables;
  }





}




function asyncFunctionCall() {
  throw new Error('Function not implemented.');
}

